//
// import _ from 'lodash';
//
// export const flattenLeaseData = (leaseData) => {
// 	const allSchedules = _.flatMap(leaseData, (lease) => {
// 		// For each lease, map over its 'data' array
// 		return lease.data.map((scheduleItem) => ({
// 			...scheduleItem, // Copy all properties from the schedule item
// 			leaseTitle: lease.leaseTitle, // Add the parent leaseTitle
// 			leaseId: lease.leaseId, // Ensure leaseId is at the top level
// 		}));
// 	});
//
// 	// We should filter out any summary/initial rows that don't have a period
// 	return allSchedules.filter(item => _.isNumber(item.period));
// };
//
//
// export const groupDataByFactor = (flattenedData, factor) => {
// 	// Use lodash's groupBy to create a dictionary-like object
// 	const grouped = _.groupBy(flattenedData, factor);
//
// 	// Convert the grouped object into an array of the format we need for the table
// 	return _.map(grouped, (items, groupValue) => ({
// 		groupValue,
// 		items: _.sortBy(items, ['leaseTitle', 'period']), // Sort items within the group
// 	}));
// };


// src/utils/leaseUtils.js
import _ from 'lodash';

// flattenLeaseData remains the same as before.
export const flattenLeaseData = (leaseData) => {
	const allSchedules = _.flatMap(leaseData, (lease) => {
		return lease.data.map((scheduleItem) => ({
			...scheduleItem,
			leaseTitle: lease.leaseTitle,
			leaseId: lease.leaseId,
		}));
	});
	return allSchedules.filter(item => _.isNumber(item.period));
};

/**
 * [MODIFIED] Groups the flattened data hierarchically.
 * 1. Groups by the primary factor.
 * 2. Within each factor group, groups by leaseTitle.
 *
 * @param {Array} flattenedData - The flat array from flattenLeaseData.
 * @param {String} factor - The primary key to group by (e.g., 'ibr', 'date').
 * @returns {Array} An array of hierarchically grouped objects.
 */
export const groupDataByFactor = (flattenedData, factor) => {
	// 1. First-level grouping by the selected factor (e.g., 'ibr')
	const primaryGrouping = _.groupBy(flattenedData, factor);

	// 2. Transform the result into the desired nested structure
	return _.map(primaryGrouping, (factorItems, groupValue) => {
		// For each factor group, perform a second-level grouping by leaseTitle
		const secondaryGrouping = _.groupBy(factorItems, 'leaseTitle');

		// Map the second-level groups into a clean array
		const leases = _.map(secondaryGrouping, (leaseItems, leaseTitle) => ({
			leaseTitle,
			items: _.sortBy(leaseItems, 'period'), // The final array of rows for this lease
		}));

		return {
			groupValue, // e.g., '10' or '20' for the 'ibr' factor
			leases: _.sortBy(leases, 'leaseTitle'), // The array of leases within this factor group
		};
	});
};